import Description from "./Description";
import { ServiceType } from "./ServiceType";
import Variant from "./Variant";

export default class Service {
	id: string;
	serviceTypeId: string;
	name: string;
	image: string;
	type: ServiceType;
	displayOrder: number;
	descriptions: Array<Description>;
	variants: Array<Variant>;
	imageSrc: string;
	itemId: string;

	constructor() {
		this.variants = new Array<Variant>();
		this.descriptions = new Array<Description>();
	}
}
